export default __webpack_public_path__ + "static/media/arrow-down.75d12b75.svg";